import { css } from '@emotion/react';
import styled from '@emotion/styled';
import type { Prismic } from '@landsbankinn/prismic';
import { device } from '@landsbankinn/ui';
import React from 'react';
import { RichTextContainer } from './RichTextContainer';
import { Slices } from './Slices';

interface IProps {
  data: any;
  template?: string;
  skipBigLetter?: boolean;
  articleAbstract?: Prismic.RichText;
}

const SpacingRules = styled.div<{
  isArticle?: boolean;
  skipBigLetter?: boolean;
  articleAbstract?: boolean;
}>`
  .intro {
    &:first-child {
      padding-top: 72px;

      @media ${device.tablet} {
        padding-top: 130px;
      }
    }
  }

  .payment-info {
    @media (max-width: 767px) {
      margin-top: 12em;
    }
  }

  .payment-info + .payment-info {
    @media (max-width: 767px) {
      margin-top: 6em;
    }
  }

  .intro + .text-points {
    padding-top: 0;
  }

  .text-images + .text-images {
    padding-top: 0;
  }
  ${(props) =>
    props.articleAbstract
      ? css`
          section:first-child {
            padding-bottom: 2px;
          }
        `
      : ''};
  // Style for first letter in articles first slice
  ${(props) =>
    props.isArticle &&
    !props.skipBigLetter &&
    css`
      > section:first-child .left {
        p:first-child::first-letter {
          font-family: 'LB-font-serif-bold';
          float: left;
          font-size: 120px;
          margin-right: 10px;
          margin-top: 6px;
          padding: 0;
          line-height: 90px;
        }
      }
    `}
`;

export function SlicesContainer({
  data,
  template,
  articleAbstract,
  skipBigLetter,
}: IProps) {
  return (
    <SpacingRules
      isArticle={template === 'article'}
      skipBigLetter={skipBigLetter}
      articleAbstract={articleAbstract !== undefined}
    >
      {articleAbstract && (
        <RichTextContainer text={articleAbstract} template="article" />
      )}
      <Slices data={data} template={template} />
    </SpacingRules>
  );
}
